import React, { ReactElement, useEffect, useState } from 'react';
import { Alert, TileRadioAccessible, ReviewAccordionFooter } from '@components';
import { Field, getIn, useFormikContext } from 'formik';
import { tile } from '@interfaces/interfaces';
import { iReviewFormValues } from '@services/ReviewService';

import gridStyles from '@pages/forms/Grid.module.scss';
import InfoIcon from '../../../../../images/info.svg';
import ErrorIcon from '../../../../../images/issue.svg';
import styles from './Step6Grounds.module.scss';

const CONTRARY_TO_LAW_FIELD_NAME = 'SelectedGroundInfo0';
const FIELD_NAME = 'selectTheOption';

const ContraryToLaw = (): ReactElement => {
  const { errors, touched, values }: { errors: any; touched: any, values: iReviewFormValues } = useFormikContext();
  const [contraryToLawErrorCount, setContraryToLawErrorCount] = useState(0);
  const [errorsBlockingSelection, setErrorsBlockingSelection] = useState(false);
  const formikContext = useFormikContext();

  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];
  useEffect(() => {
    formikContext.setFieldValue('errorOrInfoAppearsInAccordion', contraryToLawErrorCount);
    if (values.contraryToLawWasLegalMistakeMade === 'false') {
      if (getIn(values, FIELD_NAME).includes(CONTRARY_TO_LAW_FIELD_NAME)) formikContext.setFieldValue(FIELD_NAME, []);
      setErrorsBlockingSelection(true);
    }
    if (values.contraryToLawWasLegalMistakeMade === 'true') setErrorsBlockingSelection(false);
    setContraryToLawErrorCount(contraryToLawErrorCount + 1);
  },
  [
    values.contraryToLawWasLegalMistakeMade,
    values.contraryToLawCanUploadSupportingDocs,
    touched
  ]);

  const contraryToLawWasLegalMistakeMadeTitle = (
    <div className={getIn(errors, 'contraryToLawWasLegalMistakeMade') && getIn(touched, 'contraryToLawWasLegalMistakeMade') && styles.titleError}>
      <p><b>Do you believe a legal mistake was made when this fine was issued?</b></p>
      <p className={styles.subtitle}>
        Some examples of a fine being issued contrary to law:
        <ul>
          <li>the officer who issued the fine acted unlawfully, improperly or outside their authority</li>
          <li>information that the fine does not comply with the legal requirements of an infringement notice</li>
          <li>a lawful defence or exemption applies</li>
        </ul>
      </p>
    </div>
  );

  const contraryToLawCanUploadSupportingDocsTitle = (
    <div className={getIn(errors, 'contraryToLawCanUploadSupportingDocs') && getIn(touched, 'contraryToLawCanUploadSupportingDocs') && styles.titleError}>
      <p><b>Can you upload documents to support this?</b></p>
      <p className={styles.subtitle}>
        Some examples of supporting documents are:
        <ul>
          <li>evidence that the fine does not comply with legal requirements </li>
          <li>a statement about the unlawful or improper action of the issuing officer</li>
          <li>other documentation showing that the fine was issued contrary to law. </li>
        </ul>
      </p>
    </div>
  );

  const contraryToLawWasLegalMistakeMadeMessage = (
    <p>Based on the information provided, you are not eligible to request a review under this ground.</p>
  );
  const contraryToLawCanUploadSupportingDocsMessage = (
    <p>Your application may not be successful unless you provide evidence.</p>
  );

  return (
    <div>
      <div className={gridStyles.form}>
        {contraryToLawWasLegalMistakeMadeTitle}
        <Field
          name="contraryToLawWasLegalMistakeMade"
          title=""
          component={TileRadioAccessible}
          tileData={TILE_DATA}
          orientationRow
        />
        <div className={styles.alertMessageBox}>
          {values.contraryToLawWasLegalMistakeMade === 'false' && (
            <Alert
              message={contraryToLawWasLegalMistakeMadeMessage}
              theme="error"
              title=""
              icon={ErrorIcon}
              classAlt={styles.boxheight}
            />
          )}
        </div>
        {contraryToLawCanUploadSupportingDocsTitle}
        <Field
          name="contraryToLawCanUploadSupportingDocs"
          title=""
          component={TileRadioAccessible}
          tileData={TILE_DATA}
          orientationRow
        />
        <div className={styles.alertMessageBox}>
          {values.contraryToLawCanUploadSupportingDocs === 'false' && (
            <Alert
              message={contraryToLawCanUploadSupportingDocsMessage}
              theme="info"
              title=""
              icon={InfoIcon}
              classAlt={styles.boxheight}
              // color="black"
            />
          )}
        </div>

        <br />
        <span><b>Things to note:</b></span>
        <ul>
          <li>This review ground should be used only when you can show that a legal mistake was made when the fine was issued.</li>
          <br />
          <li>You should provide evidence to support your application.</li>
        </ul>

        <ReviewAccordionFooter
          selectOptionName={FIELD_NAME}
          closeOptionName="closeTheOption"
          itemOption={CONTRARY_TO_LAW_FIELD_NAME}
          isSelectButtonDisabled={errorsBlockingSelection}
          validateFieldsNames={['contraryToLawWasLegalMistakeMade', 'contraryToLawCanUploadSupportingDocs']}
          isMultiSelect={false}
        />
      </div>
    </div>
  );
};

export default ContraryToLaw;
